
export const cartas = {
  hero: {
    title: 'Cartas Contempladas',
    subtitle: 'Curadoria técnica de cartas contempladas com validação documental, análise de risco operacional e acompanhamento integral de transferência. Sem promessas. Com método.',
    cta_primary: 'Agendar Diagnóstico Estratégico',
    cta_secondary: 'Falar com Especialista'
  },
  curation: {
    label: 'Curadoria Técnica',
    title: 'Validação e Análise de Risco',
    items: [
      {
        title: 'Validação Documental Completa',
        description: 'Análise minuciosa de documentação, histórico de pagamentos, situação cadastral junto à administradora e verificação de pendências ou restrições operacionais.'
      },
      {
        title: 'Análise de Risco Operacional',
        description: 'Avaliação técnica do grupo, regulamento vigente, taxas aplicáveis, fundos de reserva e condições específicas de transferência conforme normativa da administradora.'
      },
      {
        title: 'Modelagem de Cenários',
        description: 'Projeção de custos totais de aquisição, comparação com alternativas de crédito tradicional e análise de viabilidade considerando perfil patrimonial do cliente.'
      },
      {
        title: 'Acompanhamento de Transferência',
        description: 'Gestão integral do processo de transferência junto à administradora, validação de documentação exigida e acompanhamento até conclusão da operação.'
      }
    ]
  },
  validation: {
    label: 'Processo',
    title: 'Etapas de Validação e Estruturação',
    steps: [
      {
        title: 'Diagnóstico Patrimonial',
        description: 'Análise do perfil patrimonial, objetivo de aquisição, capacidade de pagamento e horizonte de utilização do crédito contemplado.'
      },
      {
        title: 'Seleção e Curadoria',
        description: 'Identificação de cartas compatíveis com perfil, validação documental completa e análise técnica de condições operacionais.'
      },
      {
        title: 'Análise Comparativa',
        description: 'Modelagem de cenários comparando custos totais da carta contemplada versus alternativas de crédito tradicional disponíveis no mercado.'
      },
      {
        title: 'Estruturação da Operação',
        description: 'Definição de estrutura de aquisição, análise de impactos tributários e planejamento de fluxo de pagamentos conforme capacidade patrimonial.'
      },
      {
        title: 'Execução e Transferência',
        description: 'Acompanhamento integral do processo de transferência junto à administradora até conclusão e liberação do crédito para utilização.'
      }
    ]
  },
  governance: {
    label: 'Governança',
    title: 'Transparência e Limites Técnicos',
    points: [
      'A aquisição de carta contemplada não garante contemplação futura em outros grupos.',
      'Custos de transferência, taxas administrativas e fundos variam conforme regulamento da administradora.',
      'A análise técnica considera riscos operacionais, mas não elimina variáveis externas ao controle da FGT Capital.',
      'Toda operação está sujeita à aprovação cadastral e documental pela administradora do consórcio.'
    ]
  },
  cta: {
    title: 'Estruture sua Aquisição com Governança',
    subtitle: 'Agendar um diagnóstico estratégico para análise técnica de cartas contempladas compatíveis com seu perfil patrimonial.',
    button_primary: 'Solicitar Diagnóstico',
    button_secondary: 'WhatsApp'
  }
};
